import React, { FC, useEffect } from 'react'
import { VStack, Text, Box } from '@chakra-ui/react'
import { InputDefault } from './input-default'
import { useTranslation } from 'react-i18next'
import { QuestionGroup, ScenarioType, Steps } from '../../state/interfaces'
import { addAnswer, selectCurrentStep, selectScenario, useSelector } from '../../state'
import { useDispatch } from 'react-redux'
import { getCookie } from '../../scenarios/storage'
import { LeadPlanInfo } from '../miscelanea/lead-plan-info'

export interface InputEmailProps {
  placeholder?: string
  onChange?: (values: string[]) => void
  name: string
  grandImage?: string
}

export const InputEmail: FC<InputEmailProps> = ({ placeholder, onChange, name, grandImage }) => {
  const { t } = useTranslation()
  const scenario = useSelector(selectScenario)
  const dispatch = useDispatch()
  const currentStep = useSelector(selectCurrentStep)
  // const image = useMemo(() => (grandImage ? cardImageMap[grandImage] : ''), [grandImage])

  useEffect(() => {
    const province = getCookie('province')
    const stepQCookie = getCookie('stepQ')

    if (province && stepQCookie && stepQCookie === 'yes') {
      dispatch(
        addAnswer({
          stepId: Steps.PROVINCE,
          answerIds: [province],
          hidden: true,
        }),
      )
    }
  }, [])

  return (
    <VStack spacing={3} gridRowGap={4}>
      <Box>
        {currentStep!.group === QuestionGroup.LEAD && <LeadPlanInfo grandImage={grandImage} />}
        <Box minWidth={{ base: '100%', md: '600px' }}>
          {scenario &&
            (scenario.type === ScenarioType.MOBILE_REVIEWS ||
              scenario.type === ScenarioType.INTERNET_REVIEWS ||
              scenario.type === ScenarioType.MOBILE_REVIEWS_AWARD ||
              scenario.type === ScenarioType.INTERNET_REVIEWS_AWARD) && (
              <Text fontSize="xs" color="darkGrey" textAlign="center">
                {t('common_email-address')}
              </Text>
            )}
          {scenario && (scenario.type === ScenarioType.MOBILE_SEARCH_EMAIL || scenario.id === 'mobile-d') ? (
            <InputDefault placeholder={placeholder} name={name} onChange={onChange} inputType="mobile-search-email" />
          ) : scenario && scenario.type === ScenarioType.NEWSLETTER ? (
            <InputDefault placeholder={placeholder} name={name} onChange={onChange} inputType="newsletter-email" />
          ) : scenario &&
            (scenario.type === ScenarioType.EMAIL_PAGE_GO_INTERNET ||
              scenario.type === ScenarioType.EMAIL_PAGE_GO_MOBILE) ? (
            <InputDefault
              placeholder={placeholder}
              name={name}
              onChange={onChange}
              inputType="email-page-go"
              grandImage={grandImage}
            />
          ) : scenario && scenario.type === ScenarioType.DECISION_REVIEW_CONTEST ? (
            <InputDefault
              placeholder={placeholder}
              name={name}
              onChange={onChange}
              inputType="email-decision-review-contest"
              grandImage={grandImage}
            />
          ) : (
            <InputDefault
              placeholder={placeholder}
              name={name}
              onChange={onChange}
              inputType="email"
              grandImage={
                scenario && scenario?.type !== ScenarioType.LEAD_INTERNET && scenario?.type !== ScenarioType.LEAD_MOBILE
                  ? grandImage
                  : undefined
              }
            />
          )}
        </Box>
      </Box>
    </VStack>
  )
}
